module.exports = __webpack_public_path__ + "img/telluride02-2022.aec971c6.jpg";